import http from "@/services/http";

/**
 * Lista os suplementos já registrados de um paciente (tabela patient_supplements).
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>} lista de patient_supplements (`{ id, name, dosage, ... }`)
 */
export async function getSupplementsByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-supplements/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Busca suplementos na base externa (mesma fonte usada na prescrição:
 * /api/prescription/search-supplement). Normaliza para exibição/seleção.
 *
 * @param {string} texto
 * @returns {Promise<Array<{name:string, dosage:string|null, presentation:string|null,
 *   tuss_code:string|null, label:string}>>}
 */
export async function searchSupplements(texto) {
  const { data } = await http.post("/api/prescription/search-supplement", {
    texto,
  });

  return (data?.candidatos || []).slice(0, 10).map((c) => ({
    name: c.nome,
    dosage: null,
    presentation: c.categoria || null,
    tuss_code: c.id_tuss || null,
    label: [c.nome, c.categoria].filter(Boolean).join(" — "),
  }));
}

/**
 * Adiciona um ou vários suplementos de uma vez ao paciente.
 *
 * @param {number|string} patientId
 * @param {object[]} supplements lista `[{ name, dosage?, frequency?, tuss_code?, snomed_code?, notes? }]`
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function createSupplements(patientId, supplements) {
  return http.post("/api/patient-supplements/create", {
    patient_id: patientId,
    supplements: supplements.map((s) => ({
      name: s.name,
      dosage: s.dosage || null,
      frequency: s.frequency || null,
      tuss_code: s.tuss_code || null,
      snomed_code: s.snomed_code || null,
      notes: s.notes || null,
    })),
  });
}

/**
 * Remove um suplemento do paciente (soft delete).
 *
 * @param {number} id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function deleteSupplement(id) {
  return http.delete(`/api/patient-supplements/delete/${id}`);
}
